export default{
  'engagement_churn_Churn': 'Churn', // 1
  'engagement_churn_All_Users': 'All Users', // 2
  'engagement_churn_New_Users': 'New Users', // 3
  'engagement_churn_Churn_Users': 'Churn Users',

  'engagement_churn_Weekly_Churn_Users_and_Churn%': 'Weekly Churn Users and Churn%', // 4
  'engagement_churn_Biweekly_Churn_Users_and_Churn%': 'Biweekly Churn Users and Churn%', // 7
  'engagement_churn_Weekly_Churn_Users': 'Weekly Churn Users', // 5
  'engagement_churn_Monthly_Churn_Users': 'Monthly Churn Users', //
  'engagement_churn_Weekly_Churn%': 'Weekly Churn%', // 6
  'engagement_churn_Monthly_Churn%': 'Monthly Churn%', //
  'engagement_churn_Biweekly_Churn_Users': 'Biweekly Churn Users', // 8
  'engagement_churn_Biweekly_Churn%': 'Biweekly Churn%', // 9
  // Country/Region/Zone Breakdown 模块
  'engagement_churn_Country/Region/Zone_Breakdown': 'Country/Region/Zone Breakdown', // 1
  'engagement_churn_Country': 'Country',
  'engagement_churn_Region': 'Region',
  'engagement_churn_Zone': 'Zone',
  'engagement_churn_Countries': 'Countries',
  'engagement_churn_Regions': 'Regions',
  'engagement_churn_Zones': 'Zones',
  'engagement_churn_Share_Of_All': 'Share', // 14
  'engagement_churn_Churn_of_top_10_Countries': 'Churn of top 10 Countries', // 11
  'engagement_churn_Churn_of_top_10_Regions': 'Churn of top 10 Regions',
  'engagement_churn_Churn_of_top_10_Zones': 'Churn of top 10 Zones',

  'engagement_churn_Sum_Churn': 'Sum Churn', // 12
  'engagement_churn_Avg.Churn%': 'Avg.Churn%', // 13
  'engagement_churn_Churn%': 'Churn%', 
  'engagement_churn_Weekly_Payer_Churn': 'Weekly Payer Churn', // 1
  'engagement_churn_Weekly_Payer_Churn%': 'Weekly Payer Churn%', // 1
  'engagement_churn_Weekly_Churn_level_Distribution': 'Weekly Churn level Distribution',// 4
  'engagement_churn_Monthly_Churn_level_Distribution': 'Monthly Churn level Distribution',// 4
  'engagement_churn_Monthly_Payer_Churn': 'Monthly Payer Churn', // 2
  'engagement_churn_Monthly_Payer_Churn%': 'Monthly Payer Churn%', // 3
  // "engagement_churn_Accumulated": "Accumulated", // 5
  'engagement_churn_Top_10_Level': 'Top 10 Level', // 6
  'engagement_churn_Weekly/Biweekly_Churn_Users_Details': 'Weekly/Biweekly Churn Users Details', // 7
  'engagement_churn_Monthly_Churn_Users_Details': 'Monthly Churn Users Details', //
  'engagement_churn_Daily_Churn_Users_Details': 'Churn Users Details', //Ni

  'engagement_churn_Date': 'Date', // 8
  'engagement_churn_First_Day_Churn_Users_Online_Time_Distribution': 'First Day Churn Users Playtime Distribution', // 1
  'engagement_churn_Churn_Tracking_for_New_Register_Users_Level': 'Churn Tracking for New Register Users Level', // 2
  'engagement_churn_Register_Date': 'Register Date', // 3
  'engagement_churn_Registered_Users': 'Registered Users', // 4
  'engagement_churn_Tracking_Day': 'Tracking Day', // 5
  'engagement_churn_Different_Date_of_New_Register_Users_Level_Churn_on_the_Same_Tracking_Day': 'Different Date of New Register Users Level Churn on the Same Tracking Day',

  'engagement_churn_This_Week': 'This Week',
  'engagement_churn_This_Month': 'This Month',
  'engagement_churn_Last_Year': 'Last Year',
  'engagement_churn_SWLM': 'SWLM',
  'engagement_churn_SMLY': 'SMLY',

  'engagement_churn_breakdown_title': 'Churn of Top 10 ',
  'engagement_churn_breakdown_table_header2': 'Churn',
  'engagement_churn_breakdown_table_header2_sum': 'Sum Churn',
  'engagement_churn_breakdown_table_header3': 'Churn%',
  'engagement_churn_breakdown_table_header3_avg': 'Avg.Churn%',
  'engagement_churn_breakdown_share': 'Share',

  'engagement_churn_new_first_day_y_title': 'Churn Users',
  'engagement_churn_new_first_day_chart_title': 'Register Date',
  'engagement_churn_new_tacking_new_title': 'Churn Tracking for New Register Users Level',

  'engagement_churn_level_distribution_chart_level': 'Level',
  'engagement_churn_level_distribution_chart_churn_users': 'Churn Users',

  'engagement_churn_Accumulated':'Accumulated',

  'engagement_churn_rank_title_platform': 'Churn of Platform',
  'engagement_churn_rank_title_country': 'Churn of Top 10 Countries',
  'engagement_churn_rank_title_region': 'Churn of Top 10 Regions',
  'engagement_churn_rank_title_zone': 'Churn of Top 10 Zones',
  'engagement_churn_breakdown_churn': 'Churn',

  'engagement_churn_Churn_Users_and_Churn%': 'Churn Users and Churn%',
  'engagement_churn_Churn_level_Distribution_Daily': 'Churn level Distribution',
  'engagement_churn_Churn_New_User_Ni': 'New Churn Users',
  'engagement_churn_Accumualte_Churn_Users_Ni': 'Accumulated Churn Users',
  'engagement_churn_Accumualte_Churn%_Ni': 'Accumulate  Churn%',
  'engagement_churn_Accumulated_Ni': 'Accumulated',
  'engagement_churn_Sum_Churn_Ni': 'Sum New Churn',
  'engagement_churn_Churn_Ni': 'New Churn',

  'engagement_churn_Inactivity_level_1' : 'Inactivity level 1',
  'engagement_churn_Inactivity_level_2' : 'Inactivity level 2',
  'engagement_churn_Inactivity_level_3' : 'Inactivity level 3',
  'engagement_churn_Churned' : 'Churned',
  'engagement_churn_Stale' : 'Stale',

  'engagement_churn_content_Inactivity_Level_1': 'A user that has not logged in for over 7 consecutive days will be flagged as Churn Level: “Inactivity level 1”',
  'engagement_churn_content_Inactivity_Level_2': 'A user that has not logged in for over 14 consecutive days will be flagged as Churn Level: “Inactivity level 2”',
  'engagement_churn_content_Inactivity_Level_3': 'A user that has not logged in for over 28 consecutive days will be flagged as Churn Level: “Inactivity level 3”',
  'engagement_churn_content_Churned': 'A user that has not logged in for over 30 consecutive days will be flagged as Churn Level: “Churned”',
  'engagement_churn_content_Stale': 'A user that has not logged in for over 60 consecutive days will be flagged as Churn Level: “Stale”'
}
